const VIDEO_SESSION_URL = 'https://modernhealth.app.link/video-session?session=';

export const buildVideoSessionLink = (visitUuid: string | undefined) =>
  `${VIDEO_SESSION_URL}${visitUuid}`;
